import { useState } from "react";
import { requestDeleteStudentsFromGroupRoomReservation, requestValidateDeletionStudentInGroupRoomReservation } from "services/resources/library/aboutLibraryResources";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { ACTION_TYPES } from "../constants";

const useDeleteStudents = ({
    students: {
        studentList,
        setStudentList,
        selectedStudents,
        setSelectedStudents,
        setStudentsSelectedToUse
    },
    dialogs: {
        dialogShowResolveRequest,
        dialogShowNotActionForHavingAttendanceOrPenalty
    },
    setResolveType,
    setSuccessToDoActionOnStudent,
    setActionTypeOfNoActionForHaveAttendanceOrPenalty,
    addActionTypeToListActions,
    loadingRequest
}) => {
    //#region Hooks
    const dialogShowDeleteStudentsConfirmation = useShowDialogAlert();
    const dialogShowNotDeleteForLessThan2StudentsRemaining = useShowDialogAlert();
    //#endregion
    //#region States
    const [studentReservationDetailIdsToDelete, setStudentReservationDetailIdsToDelete] = useState([]);
    const [studentsWithPenaltyOrAttendanceForDeletion, setStudentsWithPenaltyOrAttendanceForDeletion] = useState([]);
    //#endregion
    //#region Functions
    const deleteStudentFromReservationList = () => {
        setResolveType(ACTION_TYPES.DELETE);
        // Cerrando modal de confirmación para agregar estudiante
        dialogShowDeleteStudentsConfirmation.set(false);
        // Abriendo modal de resolución de petición
        dialogShowResolveRequest.set(true);
        // Obteniendo estudiantes a eliminar
        const studentsToDelete = studentList
            .filter(currentStudent => selectedStudents
                .some(({ id }) => currentStudent.id === id));
        // Guardando estudiantes a eliminar a estudiantes a usar
        setStudentsSelectedToUse(studentsToDelete);
        setSuccessToDoActionOnStudent(true);
        // Guardando estudiante(s) a eliminar de la lista
        setStudentReservationDetailIdsToDelete(studentsToDelete
            .filter(({ reservationDetailId, saved }) => reservationDetailId && saved)
            .map(({ reservationDetailId }) => reservationDetailId));
        // Eliminando estudiante(s) de la lista
        setStudentList(
            studentList
            .filter(currentStudent => !selectedStudents.some(({ id }) => currentStudent.id === id)));
        // Limpiando estudiantes seleccionados
        setSelectedStudents([]);
        addActionTypeToListActions(ACTION_TYPES.DELETE);
    }
    const isValidDeletion = async () => {
        const onlySavedSelectedStudents = selectedStudents.filter(({ reservationDetailId }) => reservationDetailId);
        if (onlySavedSelectedStudents.length === 0) return true;
        loadingRequest.show("Validando...");
        const success = await requestValidateDeletionStudentInGroupRoomReservation({ 
            reservationDetailIds: onlySavedSelectedStudents
                .map(({ reservationDetailId }) => reservationDetailId) 
        });
        loadingRequest.hide();
        let newStudentsWithPenaltyOrAttendanceForDeletion = [];
        if (!success)
            newStudentsWithPenaltyOrAttendanceForDeletion = onlySavedSelectedStudents.filter(({ attended, penalty }) => attended || penalty);
        setStudentsWithPenaltyOrAttendanceForDeletion(newStudentsWithPenaltyOrAttendanceForDeletion);
        return success;
    }
    const checkIfWhenDeletingThereAre2StudentsLeft = () => {
        return studentList.length - selectedStudents.length < 2;
    }
    const openDeleteStudentDialog = async () => {
        if (checkIfWhenDeletingThereAre2StudentsLeft()) {
            dialogShowNotDeleteForLessThan2StudentsRemaining.set(true);
            return;
        }
        if (!await isValidDeletion()) {
            dialogShowNotActionForHavingAttendanceOrPenalty.set(true);
            setActionTypeOfNoActionForHaveAttendanceOrPenalty(ACTION_TYPES.DELETE);
            return;
        }
        dialogShowDeleteStudentsConfirmation.set(true)
    }
    const doRequestDeleteStudentFromReservationList = async () => {
        // Realizando petición de agregado de estudiante
        loadingRequest.show("Eliminando alumno(s)...");
        const success = await requestDeleteStudentsFromGroupRoomReservation({
            reservationDetailIds: studentReservationDetailIdsToDelete
        });
        loadingRequest.hide();
        // Gestionando errores
        if (!success) 
            throw new Error(true);
    }
    //#endregion
    return {
        studentReservationDetailIdsToDelete,
        studentsWithPenaltyOrAttendanceForDeletion,
        fns: {
            deleteStudentFromReservationList,
            openDeleteStudentDialog,
            doRequestDeleteStudentFromReservationList
        },
        dialogs: {
            dialogShowDeleteStudentsConfirmation,
            dialogShowNotDeleteForLessThan2StudentsRemaining
        }
    };
}	
    
export default useDeleteStudents;